import Vue from 'vue';
import store from '@/store';
import i18n from '@/lang';
import RequiredEmailNotice from '@/components/RequiredEmailNotice';

let pendingConfirmation = null;
let confirmedUserInfo = null;
let confirmedToken = null;

// 登录后的页面渲染完成后，提示当前用户逐条确认所有待确认邮件。
export function confirmRequiredEmails(force = false) {
  const userInfo = store.getters.userInfo;
  const token = store.getters.token;
  if (pendingConfirmation) return pendingConfirmation;
  // tips 刷新时重新检查，普通路由切换仍复用本次登录的检查结果。
  if (!force && confirmedUserInfo === userInfo && confirmedToken === token) return Promise.resolve(true);
  pendingConfirmation = new Promise(resolve => {
    const Notice = Vue.extend(RequiredEmailNotice);
    const instance = new Notice({ store, i18n });
    instance.$once('complete', confirmed => {
      if (confirmed) {
        confirmedUserInfo = userInfo;
        confirmedToken = token;
      }
      instance.visible = false;
      instance.$destroy();
      if (instance.$el.parentNode) instance.$el.parentNode.removeChild(instance.$el);
      resolve(confirmed);
    });
    instance.$mount();
    document.body.appendChild(instance.$el);
    instance.loadEmails();
  }).finally(() => {
    pendingConfirmation = null;
  });
  return pendingConfirmation;
}
